import { TypographyKeys } from './global-styling.enum';

/**
 * Single source of truth for the fixed typography keys' display labels.
 * Custom-named styles have no separate label — their key doubles as the
 * display name (same convention as custom palette groups, see
 * `RESERVED_PALETTE_GROUP_NAMES`). Consumed by both the Global Styling
 * typography editor (RHS accordion) and the Foundations typography preview
 * table, so the two can never drift out of sync.
 */
export const TYPOGRAPHY_KEY_LABELS: Record<TypographyKeys, string> = {
  [TypographyKeys.HEADING1]: 'H1',
  [TypographyKeys.HEADING2]: 'H2',
  [TypographyKeys.HEADING3]: 'H3',
  [TypographyKeys.HEADING4]: 'H4',
  [TypographyKeys.HEADING5]: 'H5',
  [TypographyKeys.HEADING6]: 'H6',
  [TypographyKeys.SUBTITLE1]: 'Subtitle 1',
  [TypographyKeys.SUBTITLE2]: 'Subtitle 2',
  [TypographyKeys.BODY1]: 'Body 1',
  [TypographyKeys.BODY2]: 'Body 2',
  [TypographyKeys.BUTTON_TEXT]: 'Button Text',
  [TypographyKeys.LABEL_TEXT]: 'Label Text',
};

export function getTypographyKeyLabel(key: string): string {
  return TYPOGRAPHY_KEY_LABELS[key as TypographyKeys] ?? key;
}
